// Custom JS Application Code

window.addEventListener('DOMContentLoaded', (event) => {
	var $ = jQuery;

	(function($) {
		"use strict"; // Start of use strict
		$(window).bind('hashchange');
		$(window).trigger('hashchange');
		$(window).scroll( function() { } );
		$(window).resize(function() { });

		const projectFilters = document.querySelectorAll('.c-project-filter');

		if (projectFilters.length) {
			const closeProjectFilters = function(exceptFilter) {
				projectFilters.forEach(function(filter) {
					if (filter === exceptFilter) {
						return;
					}

					filter.classList.remove('--is-open');

					const toggle = filter.querySelector('.filter-toggle');
					if (toggle) {
						toggle.setAttribute('aria-expanded', 'false');
					}
				});
			};

			projectFilters.forEach(function(filter) {
				const toggle = filter.querySelector('.filter-toggle');

				if (!toggle) {
					return;
				}

				toggle.addEventListener('click', function(event) {
					event.preventDefault();
					event.stopPropagation();

					const isOpen = filter.classList.contains('--is-open');
					closeProjectFilters(filter);
					filter.classList.toggle('--is-open', !isOpen);
					toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				});
			});

			document.addEventListener('click', function(event) {
				if (!event.target.closest('.c-project-filter')) {
					closeProjectFilters();
				}
			});

			document.addEventListener('keydown', function(event) {
				if (event.key === 'Escape') {
					closeProjectFilters();
				}
			});
		}

		$(window).on('load',function() {

		});

	})(jQuery); // End of use strict
});
